import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Card, CardHeader, CardContent, MenuItem } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
// import { DesignPref } from 'src/reducers/userProfile';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { DesignPreferencesData, CustDPrefData } from 'src/reducers/editDesignPreference';

export interface EditDesignPreferencePageViewProps {
    updatePreferences: (parentcode: string, listtype: string, value: string, selectedValueDesc: string, fieldvalue: string) => void;
    designPreferenceData: Array<DesignPreferencesData>;
    custDPrefData: Array<CustDPrefData>;

    onSubmitDesign: () => void;
    onReset: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        cardHead: {
            textAlign: 'center',
            maxHeight: theme.spacing(1),
            margin: theme.spacing(1)
        },
        form: {
            width: '100%', // Fix IE 11 issue.
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        centerButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        boxInput: {
            marginBottom: '5px',
            marginTop: '5px',
            width: '290px'
        },
        spaceSec: {
            marginBottom: '10px',
        },
        submit: {
            margin: theme.spacing(1, 0, 0)
        },
    })
);

// const CssTextField = withStyles({
//     root: {
//         '& .MuiInputBase-root.Mui-disabled': {
//             color: '#000',
//         },
//     },
// })(TextField);

const EditDesignPreferencePageView: React.StatelessComponent<EditDesignPreferencePageViewProps> = props => {
    const classes = useStyles({});
    const [selectedValues, setSelectedValues] = React.useState({});
    // const handleSelectChange = (parentCode: string, listType: string, value: string, selectedValueDesc: string) => {
    //     setSelectedValues(prevState => ({
    //         ...prevState,
    //         [parentCode]: {
    //             ...prevState[parentCode],
    //             [listType]: value,
    //             [`${listType}Desc`]: selectedValueDesc, // Include selectedValueDesc in the state object
    //         }
    //     }));
    // };
    const handleSelectChange = (parentCode: string, listType: string, value: string, selectedValueDesc: string) => {
        const showTextBox = selectedValueDesc === 'Others';
        setSelectedValues((prevState) => ({
            ...prevState,
            [parentCode]: {
                ...prevState[parentCode],
                [listType]: value,
                [`${listType}Desc`]: selectedValueDesc,
                [`${listType}ShowTextBox`]: showTextBox,
                [`${listType}Text`]: showTextBox ? prevState[parentCode]?.[`${listType}Text`] : '',  // Reset text if not "Others"
            },
        }));

        const currentSelection = props.custDPrefData.find(
              (data) => data.listtype === listType );
    
        // Sync with Redux
        props.updatePreferences(
            parentCode,
            listType,
            value,
            selectedValueDesc,
            showTextBox ? currentSelection?.fothervalue || '' : ''
        );
    };
    
    const handleTextBoxChange = (parentCode: string, listType: string, inputValue: string) => {
        setSelectedValues((prevState) => ({
            ...prevState,
            [parentCode]: {
                ...prevState[parentCode],
                [`${listType}Text`]: inputValue,
            },
        }));

        const currentSelection = props.custDPrefData.find(
            (data) => data.listtype === listType);
    
        // Sync text changes with Redux for fothervalue
        props.updatePreferences(
            parentCode,
            listType,
            // selectedValues[parentCode]?.[listType] || '',
            // selectedValues[parentCode]?.[`${listType}Desc`] || '',
            currentSelection?.valuecode || '',
            currentSelection?.fvaluedesc || '',
            inputValue
        );
    };

    return (
        <div className={classes.root}>
            <div className={classes.paper}>
                <Container component="main" maxWidth="md">
                    <CssBaseline />
                    <Card variant="outlined">
                        <CardHeader
                            className={classes.cardHead}
                            title={
                                <h5>Design Preferences</h5>}
                        />
                        <CardContent>
                            <form className={classes.form} noValidate>
                                {/* {props.designPreferenceData.map((item) => (
                                    <Grid container spacing={2} justify="center" alignItems="center">
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" gutterBottom>
                                                {item.parentcode}
                                            </Typography>
                                        </Grid>
                                        {item.listdata.map((listItem) => (
                                            <Grid container spacing={2} justify="center" alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        {listItem.listtype}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-required-label"
                                                            id="demo-simple-select-required"
                                                            onChange={(event) => {
                                                                props.updatePreferences(event.target.value as string, 1);
                                                            }

                                                            }
                                                            value={
                                                                listItem.dropvalue.find((dropItem) => dropItem.isdefault === 'Yes')?.valuecode || ''
                                                            }
                                                        >
                                                            <MenuItem disabled value="">
                                                                <em>None</em>
                                                            </MenuItem>
                                                            {listItem.dropvalue.map((listValue) => (
                                                                <MenuItem value={listValue.valuecode}>{listValue.valuedesc}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                ))} */}

                                {/* {props.designPreferenceData.map((item, index) => (
                                    <Grid container spacing={2} justify="center" alignItems="center" key={item.parentcode}>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" gutterBottom>
                                                {item.parentcode}
                                            </Typography>
                                        </Grid>
                                        {item.listdata.map((listItem) => (
                                            <Grid container spacing={3} className={classes.spaceSec} justify="center" alignItems="center" key={listItem.listtype}>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        {listItem.listtype}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl size="small" className={classes.forms}>
                                                        {selectedValues[item.parentcode] && selectedValues[item.parentcode][`${listItem.listtype}Desc`] === 'Any Other Value (In MM)' ||
                                                            props.custDPrefData.find(data => data.listtype === listItem.listtype && data.other === 't') ?
                                                            (
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    className={classes.boxInput}
                                                                    value={props.custDPrefData.find(data => data.listtype === listItem.listtype)?.valuedesc === 'Any Other Value (In MM)' ?
                                                                        '' : props.custDPrefData.find(data => data.listtype === listItem.listtype)?.valuedesc
                                                                    }
                                                                    onChange={(event) =>
                                                                        props.updatePreferences(item.parentcode, listItem.listtype, '' as string, event.target.value as string)
                                                                    }
                                                                />
                                                            ) : (
                                                                <Select
                                                                    labelId="demo-simple-select-required-label"
                                                                    id="demo-simple-select-required"
                                                                    onChange={(event) => {
                                                                        const selectedOption = listItem.dropvalue.find(option => option.valuecode === event.target.value);
                                                                        const selectedValueDesc = selectedOption ? selectedOption.valuedesc : ''; // Get the valuedesc corresponding to selectedValue
                                                                        handleSelectChange(
                                                                            item.parentcode as string, listItem.listtype as string,
                                                                            event.target.value as string, selectedValueDesc as string
                                                                        );
                                                                        props.updatePreferences(item.parentcode, listItem.listtype, event.target.value as string, selectedValueDesc as string);
                                                                    }}
                                                                    value={props.custDPrefData.some(data => data.listtype === listItem.listtype) ?
                                                                        (props.custDPrefData.find(data => data.listtype === listItem.listtype)?.valuecode || '') :
                                                                        ((selectedValues[item.parentcode] && selectedValues[item.parentcode][listItem.listtype]) ||
                                                                            (listItem.dropvalue.find((dropItem) => dropItem.isdefault === 'Yes')?.valuecode || ''))
                                                                    }

                                                                >
                                                                    <MenuItem disabled value="">
                                                                        <em>None</em>
                                                                    </MenuItem>
                                                                    {listItem.dropvalue.map((listValue) => (
                                                                        <MenuItem key={listValue.valuecode} value={listValue.valuecode} data-valuedesc={listValue.valuedesc}>
                                                                            {listValue.valuedesc}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                ))} */}

                                {props.designPreferenceData.map((item, index) => (
                                    <Grid container spacing={2} justify="center" alignItems="center" key={item.parentcode}>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" gutterBottom>
                                                {item.parentcode}
                                            </Typography>
                                        </Grid>
                                        {item.listdata.map((listItem) => {
                                            const existingPreference = props.custDPrefData.find(
                                                (data) => data.listtype === listItem.listtype
                                            );
                                            const currentSelectedOption = listItem.dropvalue.find(
                                                (option) => option.valuecode === existingPreference?.valuecode
                                            );

                                            // Check if "Others" is selected
                                            const isOthersSelected = currentSelectedOption?.valuedesc === 'Others';
                                            // Use the `shouldShowTextField` variable to control TextField visibility based on the current selection
                                            const shouldShowTextField = selectedValues[item.parentcode]?.[`${listItem.listtype}ShowTextBox`] || isOthersSelected;

                                            const textFieldValue = isOthersSelected
                                                ? (existingPreference?.othervalue || selectedValues[item.parentcode]?.[`${listItem.listtype}Text`] || '')
                                                : selectedValues[item.parentcode]?.[`${listItem.listtype}Text`] || '';                                    

                                            return (
                                                <Grid container spacing={3} className={classes.spaceSec} justify="center" alignItems="center" key={listItem.listtype}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Typography variant="subtitle2" gutterBottom>
                                                            {listItem.listtype}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={shouldShowTextField ? 3 : 6}>
                                                        <FormControl size="small" className={classes.forms}>
                                                            <Select
                                                                onChange={(event) => {
                                                                    const selectedOption = listItem.dropvalue.find(
                                                                        (option) => option.valuecode === event.target.value
                                                                    );                                                                    
                                                                    const selectedValueDesc = selectedOption ? selectedOption.valuedesc : '';
                                                                    handleSelectChange(item.parentcode, listItem.listtype, event.target.value as string, selectedValueDesc);
                                                                    // const fieldValue = selectedValueDesc === 'Others' ? existingPreference?.fothervalue || '' : '';
                                                                    
                                                                    // props.updatePreferences(
                                                                    //     item.parentcode,
                                                                    //     listItem.listtype,
                                                                    //     event.target.value as string,
                                                                    //     selectedValueDesc,
                                                                    //     fieldValue
                                                                    // );
                                                                }}
                                                                value={existingPreference ? existingPreference.valuecode || '' : ''}
                                                            >
                                                                <MenuItem disabled value="">
                                                                    <em>None</em>
                                                                </MenuItem>
                                                                {listItem.dropvalue.map((listValue) => (
                                                                    <MenuItem key={listValue.valuecode} value={listValue.valuecode}>
                                                                        {listValue.valuedesc}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    {shouldShowTextField && (
                                                        <Grid item xs={12} sm={3}>
                                                            <TextField
                                                                fullWidth
                                                                inputProps={{ maxLength: 50 }}
                                                                size="small"
                                                                value={textFieldValue}
                                                                onChange={(event) => {
                                                                    const inputValue = event.target.value;

                                                                    handleTextBoxChange(item.parentcode, listItem.listtype, inputValue);

                                                                    // const currentSelection = props.custDPrefData.find(
                                                                    //     (data) => data.listtype === listItem.listtype
                                                                    // );

                                                                    // props.updatePreferences(
                                                                    //     item.parentcode,
                                                                    //     listItem.listtype,
                                                                    //     currentSelection?.valuecode || '',
                                                                    //     currentSelection?.valuedesc || '',
                                                                    //     inputValue
                                                                    // );
                                                                }}
                                                            />
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                ))}
                                <Grid container spacing={2} justify="center" alignItems="center">
                                    <Grid item sm={6} className={classes.centerButton}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color="primary"
                                            className={classes.submit}
                                            onClick={props.onSubmitDesign}
                                        >
                                            Update
                                        </Button>
                                    </Grid>
                                    <Grid item sm={6} className={classes.centerButton}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color="secondary"
                                            className={classes.submit}
                                            onClick={props.onReset}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Container>
            </div>
        </div >
    );
};

export default EditDesignPreferencePageView;



// WEBPACK FOOTER //
// ./src/components/layouts/EditDesignPreferences.tsx